import { v4 } from 'uuid'

const getRandomString = () => v4().split('-').join('')

export { getRandomString }
